import { render, staticRenderFns } from "./ManageEvents.vue?vue&type=template&id=73c794c6&"
import script from "./ManageEvents.vue?vue&type=script&lang=js&"
export * from "./ManageEvents.vue?vue&type=script&lang=js&"
import style0 from "./ManageEvents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports